import { useIntl } from "react-intl";
import Select from "@rio-cloud/rio-uikit/Select";
import "./styles.css";
import { ScheduleViewType } from "../..";
import SearchAutocomplete from "../../../../../../components/form/searchAutocomplete";
import { ServiceBaySchedule } from "../../../../../../models/serviceBay";
import { useMediaQuery } from "@mui/material";

interface ICalendarTitleProps {
  currentDate: Date;
  firstWeekDay: Date;
  lastWeekDay: Date;
  handleScheduleSidebar: () => void;
  scheduleViewType: ScheduleViewType;
  setScheduleViewType: (scheduleViewType: ScheduleViewType) => void;
  onCreateSchedule: () => void;
  consultantMonthSchedule: ServiceBaySchedule[];
  goToDate: (date: Date) => void;
  openScheduleModal: (schedule: ServiceBaySchedule) => void;
}

const Title = ({
  currentDate,
  firstWeekDay,
  lastWeekDay,
  scheduleViewType,
  handleScheduleSidebar,
  setScheduleViewType,
  onCreateSchedule,
  consultantMonthSchedule,
  goToDate,
  openScheduleModal
}: ICalendarTitleProps) => {

  const isResponsiveView = useMediaQuery("(max-width: 1024px)");
  const intl = useIntl();

  const getFormatedFirstWeekDay = () => {
    if (firstWeekDay.getMonth() !== lastWeekDay.getMonth()) {
      return firstWeekDay
        .toLocaleDateString(intl.locale, { day: "2-digit", month: "long" })
        .replace(/ de /g, " ");
    } else {
      return firstWeekDay.toLocaleDateString(intl.locale, { day: "2-digit" });
    }
  };

  const renderFirstWeekFullYear = () => {
    return (
      <span className="text-normal">
        {firstWeekDay.getFullYear() !== lastWeekDay.getFullYear()
          ? firstWeekDay.getFullYear()
          : ""}
      </span>
    );
  };

  return (
    <div
      className={`${isResponsiveView ? 'mobile-calendar-header' : 'height-80'} width-100pct ${isResponsiveView ? 'display-flex flex-direction-column' : 'display-grid gap-20'}`}
      style={{ 
        borderBottomWidth: 1,
        gridTemplateColumns: isResponsiveView ? undefined : '1fr auto'
      }}
    >
      <div className={`display-flex align-items-center ${isResponsiveView ? 'mobile-date-row padding-10' : 'padding-15'}`} style={{ minWidth: 0, flexWrap: isResponsiveView ? 'wrap' : 'nowrap', gap: isResponsiveView ? '10px' : undefined }}>
        <span
          className="rioglyph rioglyph-th-list padding-right-15 text-size-20 cursor-pointer"
          style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}
          onClick={handleScheduleSidebar}
        />
        <div className="display-flex align-items-center gap-15" style={{ width: isResponsiveView ? '100%' : 'auto', minWidth: 0, flexWrap: 'nowrap', flex: isResponsiveView ? undefined : 1 }}>
          {scheduleViewType === "month" && (
            <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : ''}`} style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, whiteSpace: 'nowrap' }}>
              {currentDate.toLocaleDateString(intl.locale, { month: "long" })}{" "}
              <span className="text-normal">{lastWeekDay.getFullYear()}</span>
            </span>
          )}

          {scheduleViewType === "week" && (
            <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : ''}`} style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, whiteSpace: 'nowrap' }}>
              {getFormatedFirstWeekDay()}
              {renderFirstWeekFullYear()}-
              {lastWeekDay
                .toLocaleDateString(intl.locale, { day: "2-digit", month: "long" })
                .replace(/ de /g, " ")}{" "}
              <span className="text-normal">{lastWeekDay.getFullYear()}</span>
            </span>
          )}

          {scheduleViewType === "day" && (
            <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : ''}`} style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, whiteSpace: 'nowrap' }}>
              <span className="text-normal">
                {currentDate.toLocaleDateString(intl.locale, { weekday: "long" })},{" "}
              </span>
              {currentDate
                .toLocaleDateString(intl.locale, { day: "2-digit", month: "long" })
                .replace(/ de /g, " ")}
              <span className="text-normal"> {currentDate.getFullYear()}</span>
            </span>
          )}
          
          {!isResponsiveView && (
            <div style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 1, minWidth: 0 }}>
              <Select
                placeholder={intl.formatMessage({ id: "intl-msg:dealership.title.viewTypePlaceholder" })}
                options={[
                  { id: "month", label: intl.formatMessage({ id: "intl-msg:dealership.title.month" }) },
                  { id: "week", label: intl.formatMessage({ id: "intl-msg:dealership.title.week" }) },
                  { id: "day", label: intl.formatMessage({ id: "intl-msg:dealership.title.day" }) },
                ]}
                onChange={(item) => setScheduleViewType(item!.id as ScheduleViewType)}
                btnClassName="btn btn-primary btn-outline"
                value={[scheduleViewType]}
              />
            </div>
          )}
          
          {!isResponsiveView && (
            <div style={{ display: 'inline-flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
              <SearchAutocomplete
                id="5"
                placeholder={intl.formatMessage({ id: "intl-msg:dealership.title.searchByChassis" })}
                fetchOptions={async (searchTerm: string) => {
                  return consultantMonthSchedule
                    .filter((schedule) => schedule.occurrence?.vehicleChassis?.includes(searchTerm))
                    .map((schedule) => ({
                      vehicleChassis: schedule.occurrence?.vehicleChassis,
                      box: schedule.serviceBay?.name,
                      schedule: schedule
                    }));
                }}
                optionLabel={{
                  vehicleChassis: intl.formatMessage({ id: "intl-msg:monitoring.table.chassis" }),
                  box: intl.formatMessage({ id: "intl-msg:dealership.title.box" }),
                }}
                onSelectedOption={(e) => {
                  if (e.schedule?.startDate) {
                    goToDate(e.schedule?.startDate);
                  }
                  if (e.schedule) {
                    openScheduleModal(e.schedule);
                  }
                }}
                overlay
                overlayClassName="!w-[300px]"
              />
            </div>
          )}
        </div>
      </div>
      
      {isResponsiveView && (
        <div className="display-flex align-items-center padding-10 gap-10" style={{ width: '100%' }}>
          <Select
            placeholder={intl.formatMessage({ id: "intl-msg:dealership.title.viewTypePlaceholder" })}
            options={[
              { id: 'month', label: intl.formatMessage({ id: "intl-msg:dealership.title.month" }) },
              { id: 'week', label: intl.formatMessage({ id: "intl-msg:dealership.title.week" }) },
              { id: 'day', label: intl.formatMessage({ id: "intl-msg:dealership.title.day" }) }
            ]}
            onChange={item => setScheduleViewType(item!.id as ScheduleViewType)}
            btnClassName='btn btn-primary btn-outline mobile-select'
            value={[scheduleViewType]}
          />
          <button
            type="button"
            className="btn bg-highlight-darker mobile-create-btn ml-4"
            onClick={onCreateSchedule}
          >
            <span className="text-capitalize">{intl.formatMessage({ id: "intl-msg:dealership.title.create" })}</span>
            <span className="rioglyph rioglyph-plus-sign" aria-hidden="true" />
          </button>
        </div>
      )}
      
      {isResponsiveView && (
        <div className="w-full padding-10">
            <SearchAutocomplete
              id="5"
              placeholder={intl.formatMessage({ id: "intl-msg:dealership.title.searchByChassis" })}
              fetchOptions={async (searchTerm: string) => {
                return consultantMonthSchedule
                  .filter((schedule) => schedule.occurrence?.vehicleChassis?.includes(searchTerm))
                  .map((schedule) => ({
                    vehicleChassis: schedule.occurrence?.vehicleChassis,
                    box: schedule.serviceBay?.name,
                    schedule: schedule
                  }));
              }}
              optionLabel={{
                vehicleChassis: intl.formatMessage({ id: "intl-msg:monitoring.table.chassis" }),
                box: intl.formatMessage({ id: "intl-msg:dealership.title.box" }),
              }}
              onSelectedOption={(e) => {
                if (e.schedule?.startDate) {
                  goToDate(e.schedule?.startDate);
                }
                if (e.schedule) {
                  openScheduleModal(e.schedule);
                }
              }}
              overlay
              overlayClassName="!w-[300px]"
            />
          </div>
      )}
      
      {!isResponsiveView && (
      <div className="display-flex align-items-center justify-content-end padding-20">
        <button
          type="button"
          className="btn bg-highlight-darker padding-7"
          onClick={onCreateSchedule}
        >
          <span className="text-capitalize padding-right-5">
            {intl.formatMessage({ id: "intl-msg:monitoring.createScheduling" })}
          </span>
          <span className="rioglyph rioglyph-plus-sign" aria-hidden="true" />
        </button>
      </div>
      )}
    </div>
  );
};

export default Title;
